// Meta Pixel helpers. The base snippet lives in public/index.html (Django only
// renders it when a pixel ID is configured, so window.fbq is absent in dev).
export const trackPixel = (event, params = {}, eventID) =>
  window.fbq?.('track', event, params, eventID ? { eventID } : undefined);
